import { __assign } from "tslib";
import React from 'react';
import Image from './Image';
export var ImageFullViewWrapper = function (props) {
    return React.createElement(Image, __assign({}, props));
};
ImageFullViewWrapper.displayName = 'ImageFullViewWrapper';
export default ImageFullViewWrapper;
//# sourceMappingURL=index.js.map